import { type inferQueryKeyStore, mergeQueryKeys } from '@lukemorales/query-key-factory';
import { addOns } from './add-ons';
import { addToShipment } from './add-to-shipment';
import { cart } from './cart';
import { deliveries } from './deliveries';
import { enterCheckout } from './enter-checkout';
import { facilities } from './facilities';
import { facilityAlerts } from './facility-alert';
import { insurances } from './insurances';
import { onboarding } from './onboarding';
import { orderBundling } from './order-bundling';
import { paymentMethods } from './paymentMethods';
import { prescriptions } from './prescriptions';
import { pricing } from './pricing';
import { products } from './products';
import { quantityOptions } from './quantityOptions';
import { rateShipment } from './rateShipment';
import { scheduledDowntime } from './scheduledDowntime';
import { shipmentFees } from './shipment-fees';
import { shipmentPaymentMethods } from './shipmentPaymentMethods';
import { shipmentTips } from './shipmentTips';
import { shipments } from './shipments';
import { snoozeOptions } from './snooze-options';
import { userSubscriptions } from './subscriptions';
import { verifications } from './verifications';
import { wundercomMessages } from './wundercom-messages';
import { announcements } from '~shared/queries/query-keys/announcements';
import { hubReferralInfoRequestConfigs } from '~shared/queries/query-keys/hub-referral-info-request-configs';
import { instructionalVideos } from '~shared/queries/query-keys/instructionalVideos';
import { onboardingConfigs } from '~shared/queries/query-keys/onboarding-configs';

export const queries = mergeQueryKeys(
  addOns,
  addToShipment,
  announcements,
  cart,
  deliveries,
  enterCheckout,
  facilities,
  facilityAlerts,
  hubReferralInfoRequestConfigs,
  insurances,
  onboarding,
  onboardingConfigs,
  orderBundling,
  paymentMethods,
  prescriptions,
  pricing,
  quantityOptions,
  rateShipment,
  products,
  scheduledDowntime,
  instructionalVideos,
  shipmentFees,
  shipmentPaymentMethods,
  shipmentTips,
  shipments,
  snoozeOptions,
  userSubscriptions,
  verifications,
  wundercomMessages,
);
export type QueryKeys = inferQueryKeyStore<typeof queries>;
